// @ts-ignore
import { useRuntimeConfig } from '#imports'

let assets: any = {}

export default function (url: string) {
	if (url.includes('/assets/')) {
		if (!assets.length)
			assets = {
				...Object.fromEntries(
					// @ts-ignore
					Object.entries(import.meta.glob('/assets/**/*', { eager: true })).map(([key, value]) => [url.split('/')[0]+key, value.default])
				),
				...Object.fromEntries(
					// @ts-ignore
					Object.entries(import.meta.glob('/assets/*', { eager: true })).map(([key, value]) => [url.split('/')[0]+key, value.default])
				)
			}
		url = assets[url]
	} else {
		const baseUrl: string = useRuntimeConfig().app.baseURL
		if ((url.startsWith('@') || url.startsWith('~')) && !url.includes('public'))
			url = baseUrl + url.substring(1, url.length)
		if (!url.startsWith('http') && !url.startsWith(baseUrl))
			url = url.startsWith('/') ? baseUrl + url : `${baseUrl}/${url}`
	}
	if (!(url.startsWith('http:') || url.startsWith('https:')) && location !== undefined)
		url = location.protocol + '//' + location.hostname + `${['80','443'].includes(location.port) || !location.port ? '' : ':'+location.port}` + url
	return url
}
